import { render, staticRenderFns } from "./AssetUploader.vue?vue&type=template&id=c120b878&scoped=true&"
import script from "./AssetUploader.vue?vue&type=script&lang=ts&"
export * from "./AssetUploader.vue?vue&type=script&lang=ts&"
import style0 from "./AssetUploader.vue?vue&type=style&index=0&id=c120b878&prod&lang=scss&"
import style1 from "./AssetUploader.vue?vue&type=style&index=1&id=c120b878&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c120b878",
  null
  
)

export default component.exports